export default __webpack_public_path__ + "static/media/provider_7.68aceae8.png";